import { render } from "./dutySelect.vue?vue&type=template&id=a4bf412a"
import script from "./dutySelect.vue?vue&type=script&lang=js"
export * from "./dutySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__